import React__default from 'react';
import { useDayPicker } from '../useDayPicker.js';

/**
 * Render the button to navigate to the next month in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function NextMonthButton(props) {
    const { components } = useDayPicker();
    return React__default.createElement(components.Button, { ...props });
}

export { NextMonthButton };
